import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import SiteFooter from "../partials/site-footer";
import HelmetWrapper from "../partials/helmet-wrapper";
import SiteHeader from "../partials/site-header";
import TripSummary from "../partials/trip-summary";
import { getParamFromQueryString } from "../../utils/app-helpers";

const { siteMetadata: config } = GatsbyConfig;

export default class CallToBookPage extends React.Component {
  render() {
    if (typeof window === "undefined") return <div />;
    const trip = this.props.trip;
    const tripData = config.trips[trip];
    const room = getParamFromQueryString("room", window.location.href);
    const pay = getParamFromQueryString("pay", window.location.href);
    const roomData = tripData.rooms[room];
    const title = `Call to Book – ${tripData.name} ${tripData.year}`;
    const description =
      `Call ${config.phone} now to book your reservation on the ` +
      `Love Song Couples Getaway | ${tripData.name} ${tripData.year}`;

    return (
      <div className={`page-call-to-book trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <SiteHeader trip={trip} />
        <main>
          <div className="wrap">
            <div className="content centered">
              <h1>
                Call Now to Book <br />
                <a href={`tel://${config.phoneDashed}`}>{config.phone}</a>
              </h1>
              <blockquote className="promo-code">
                <p>
                  Use Promo Code
                  <i className="fa fa-tag" />
                </p>
                <big>{tripData.slug.toUpperCase()}</big>
              </blockquote>
              <TripSummary room={roomData} trip={trip} data-pay={pay} />
            </div>
          </div>
        </main>
        <SiteFooter trip={trip} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/call-to-book.js